export const FORM_UNAVAILABLE_MESSAGE = "O formulário está temporariamente indisponível. Tente novamente mais tarde.";

export function getPublicConfig() {
  return globalThis.GERTH_PUBLIC_CONFIG || {};
}

export function requirePortalConfig() {
  const publicConfig = getPublicConfig();

  if (!publicConfig.supabaseUrl || !publicConfig.supabasePublishableKey) {
    throw new Error("Portal ainda não conectado ao Supabase.");
  }

  return publicConfig;
}

export function requirePublicConfig() {
  const publicConfig = requirePortalConfig();

  if (publicConfig.releaseStatus !== "release-ready") {
    throw new Error(FORM_UNAVAILABLE_MESSAGE);
  }

  return publicConfig;
}
